import { 
  isString,
  isObject
} from 'lodash'
const _jslib_isIE=document.all?true:false;
const _jslib_isNS=document.layers?true:false;
const _jslib_isNS6=document.getElementById&&!document.all?true:false;

export const getElementById = id => {

  if(_jslib_isIE) {
      return document.all[id];
  } else if(_jslib_isNS) {
      return document.layers[id];
  } else if (_jslib_isNS6) {
      return document.getElementById(id);
  }
  
  return null;
}

export const addClass = (id, addclass) =>  {

  const elem = getElementById(id)

  let classes = elem.className.split(' ')
  classes.push(addclass)
  elem.className = classes.join(' ')
}

export const removeClass = (id, removeclass) =>  {

  const elem = getElementById(id)

  let classes = elem.className.split(' ')
  classes = classes.filter(c => c != removeclass)
  elem.className = classes.join(' ')
}

export const getWindowSize = () => {
  
  const w = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth
  const h = window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight

  return {
    w: w,
    h: h,
    o:  w <= h ? 'portrait' : 'landscape'
  }
}

export const removeElement = id =>  {

  const elem = getElementById(id)
  elem.parentNode.removeChild(elem)
}

// Helpers 

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

const formatStringToCamelCase = str => {
  const splitted = str.split("-");
  if (splitted.length === 1) return splitted[0];
  return (
    splitted[0] +
    splitted
      .slice(1)
      .map(word => word[0].toUpperCase() + word.slice(1))
      .join("")
  );
};

export const extractstyle = stylestr => {

  if(isString(stylestr)) {
  
    const style = {};
    stylestr.split(";").forEach(el => {

      const dotsindex = el.indexOf(':')
      
      if(dotsindex == -1) return

      const property = el.substring(0, dotsindex)
      const value = el.substring(dotsindex + 1)

      const formattedProperty = formatStringToCamelCase(property.trim());
      style[formattedProperty] = value.trim();
    });

    return style;
  }  

  /*  

  if(isObject(stylestr)) {

    const style = Object.keys(stylestr)
    .reduce((styles, key) => {

      return {
        ...styles,
        ...stylestr[key]
      }
    }, {})

    return style;
  }    

  */
}